var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCo3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vuesax_outline_eye",
    "data-name": "vuesax/outline/eye",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_eye-2",
    "data-name": "vuesax/outline/eye"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eye"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.412,10.464A5.331,5.331,0,0,1,0,5.232,5.331,5.331,0,0,1,5.412,0a5.331,5.331,0,0,1,5.412,5.232A5.331,5.331,0,0,1,5.412,10.464Zm0-8.651A3.483,3.483,0,0,0,1.875,5.232a3.484,3.484,0,0,0,3.537,3.42,3.485,3.485,0,0,0,3.538-3.42A3.484,3.484,0,0,0,5.412,1.813Z",
    transform: "translate(9.587 9.268)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M13.181,21.8c-4.691,0-9.134-2.651-12.188-7.273a7.116,7.116,0,0,1,0-7.25C4.06,2.651,8.5,0,13.181,0S22.3,2.651,25.356,7.274a7.111,7.111,0,0,1,0,7.25C22.3,19.147,17.864,21.8,13.181,21.8Zm0-19.985c-4.04,0-7.9,2.347-10.6,6.44a5.347,5.347,0,0,0,0,5.293c2.7,4.093,6.562,6.44,10.6,6.44s7.9-2.347,10.6-6.44a5.347,5.347,0,0,0,0-5.293C21.083,4.16,17.22,1.813,13.181,1.813Z",
    transform: "translate(1.82 3.601)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M30,0V29H0V0Z",
    fill: "none",
    opacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCo3);
export default __webpack_public_path__ + "static/media/co3.b2e1506f5d4a4353bf16b4b4c11e75c2.svg";
export { ForwardRef as ReactComponent };